import { useState } from "react";
import { DocsSidebar } from "./DocsSidebar";

interface DocsLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  toc?: React.ReactNode;
  hideSidebar?: boolean;
}

export function DocsLayout({
  children,
  sidebar: _sidebar,
  toc,
  hideSidebar = false,
}: DocsLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-[calc(100vh-64px)]">
      {!hideSidebar && (
        <>
          <div
            className={`fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity ${
              sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
            onClick={() => setSidebarOpen(false)}
          />

          <aside
            className={`fixed top-16 left-0 bottom-0 w-64 bg-dark-card border-r border-dark-border z-40 lg:z-0 transition-transform lg:transform-none ${
              sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
            }`}
          >
            <DocsSidebar onClose={() => setSidebarOpen(false)} />
          </aside>
        </>
      )}

      <div className="flex">
        {!hideSidebar && <div className="hidden lg:block w-64 shrink-0" />}

        <main className="flex-1 min-w-0 px-4 py-8 lg:px-8">
          {!hideSidebar && (
            <button
              className="lg:hidden fixed bottom-4 left-4 z-30 p-3 bg-dark-card border border-dark-border rounded-full shadow-lg text-warm-100 hover:text-warm-50"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open sidebar"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </button>
          )}

          {children}
        </main>

        {toc && <div className="hidden xl:block w-64 shrink-0" />}
      </div>
    </div>
  );
}
